import { toggleActiveButton } from "./utils/func-toggle-active-button";

class Partners {
	constructor() {
		toggleActiveButton();
	}
}

export default Partners;
